<p-toast   position="center" ></p-toast>

<form [formGroup]="formulario" (ngSubmit)="enviando()">
        <div class="p-grid" >
                <!-- <div class="p-col-12" *ngIf="localizacao" style="text-align: center;">
                        <div class="localizador" >
                                <div>
                                        {{localizacao.geoplugin_city}}
                                </div>
                                
                                <div>
                                        {{localizacao.geoplugin_region}}
                                </div>
                        </div>
                </div> -->
               
                <div class="p-col-4">
                        <span style="font-weight: bolder" pTooltip="Data do lançamento" tooltipPosition="right">Nome*</span> <br>
                        <input pInputText  type="text" formControlName="nome" style="width:100%"/>
                        <div class="has-error" *ngIf="verificaValidTouched('nome')">Campo obrigatório</div>
                </div>
            <div class="p-col-4">
                    <span style="font-weight: bolder" pTooltip="Data do lançamento" tooltipPosition="right">Email*</span> <br>
                    <input pInputText  type="text" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$" formControlName="email" style="width:100%"/>
                    <div class="has-error" *ngIf="verificaValidTouched('email')">Campo obrigatório</div>
            </div>

            <div class="p-col-4">
                    <span style="font-weight: bolder" pTooltip="Data do lançamento" tooltipPosition="right">Telefone*</span> <br>
                    <input pInputText  type="text" formControlName="telefone" style="width:100%"/>
                    <div class="has-error" *ngIf="verificaValidTouched('telefone')">Campo obrigatório</div>
            </div>
            

            <div class="p-col-12">
                    <span style="font-weight: bolder" pTooltip="Data do lançamento" tooltipPosition="right">Categoria*</span> <br>             
                    <p-dropdown [options]="categorias" formControlName="categoria"[style]="{'width':'100%'}" ></p-dropdown>
                    <div class="has-error" *ngIf="verificaValidTouched('categoria')">Campo obrigatório</div>
            </div>

            <div *ngIf="formulario && formulario.controls.categoria?.value=='solicitacao'" style="text-align: center;" class="p-col-12">
                <div class="aviso">
                      ⚠️  Em caso de solicitação de CTC (certidão de tempo de contribuição), é necessário informar o <b>seu endereço</b> e <b>para onde</b> será averbada a certidão.
                </div>
                
            </div>
           

            <div class="p-col-12">
                    <span style="font-weight: bolder" pTooltip="Data do lançamento" tooltipPosition="right">Mensagem*</span> <br>
                    <textarea [rows]="10" [cols]="93" style="width:100%" autoResize="autoResize" pInputTextarea formControlName="mensagem"></textarea>
                    <div class="has-error" *ngIf="verificaValidTouched('mensagem')">Campo obrigatório</div>
            </div>
        </div>
    
    
        <button pButton type="button" label="Enviar Mensagem" class="ui-button-rounded ui-button-success" (click)="enviando()"></button>
        

</form>


<app-pesquisa></app-pesquisa>
<br><br>
<p-fieldset legend="Regulamentação" [toggleable]="true" [collapsed]="true">
        <app-lista-arquivos [miniMode]="true" categoria="regulamentacaoFale"></app-lista-arquivos>
</p-fieldset>


